<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <ResizeRow :sliderWidth="3" width="100%" :height="gridHeight" style="padding-bottom:1px;">
        <div class='company-grid' style="height:100%">
          <dx-data-grid ref='refCompanyGrid'
            :data-source='companyInfoList'
            :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
            :hover-state-enabled = "true" :allowColumnResizing = 'true'
            column-resizing-mode = 'widget' :allow-column-reordering = "true"
            height='100%' :row-alternation-enabled="true"
            keyExpr="seqId" :focusedRowEnabled="true" :focused-row-key.sync='focusedRowKey'
            :auto-navigate-to-focused-row="true" @focused-row-changed="onFocusedRowChanged"
            @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
            @row-updated='onRowUpdated' @row-updating='onUpdating'
            @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
            @init-new-row='onInitNewRow' @exporting="onExcelExporting"
            @rowDblClick ='onRowDbClick'
          >
            <DxSearchPanel
              :visible="true"
              placeholder="검색..."
            />
            <DxExport
              :enabled="true"
            />
            <DxFilterRow
              :visible="true"
              apply-filter="auto"
            />
            <DxStateStoring
              :enabled="false"
              type="localStorage"
              storage-key="customer"
            />
            <DxEditing
              :allow-deleting="isCRUD"
              :allow-updating="isCRUD"
              :allow-adding="true"
              :use-icons="true"
              mode='popup'
            >
              <DxPopup
                :show-title="true"
                :width="900"
                :height="740"
                title="고객사등록"
              >
                <dx-position
                  my="center"
                  at="center"
                  of="window"
                />
              </DxPopup>
              <DxForm>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="기본정보"
                >
                  <DxItem data-field="고객사코드"/>
                  <DxItem data-field="컨설턴트"/>
                  <DxItem data-field="고객사명"/>
                  <DxItem data-field="회사규모"/>
                  <DxItem data-field="연간매출액"/>
                  <DxItem data-field="종업원수"/>
                  <DxItem data-field="본사주소"/>
                  <DxItem data-field="상장여부"/>
                  <DxItem data-field="사업자번호"/>
                  <DxItem data-field="업종"/>
                  <DxItem data-field="홈페이지"/>
                  <DxItem data-field="계약단계"/>
                  <DxItem data-field="유치경로"/>
                  <DxItem data-field="평균수수료"/>
                  <DxItem
                    :col-span="2"
                    :editor-options="{ height: 100 }"
                    data-field="고객사소개"
                    editor-type="dxTextArea"
                  />
                </DxItem>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="담당자정보"
                >
                  <DxItem data-field="담당자성명"/>
                  <DxItem data-field="담당자부서"/>
                  <DxItem data-field="담당자직급"/>
                  <DxItem data-field="연락처"/>
                  <DxItem data-field="휴대폰"/>
                  <DxItem data-field="이메일"/>
                </DxItem>
              </DxForm>
            </DxEditing>
            <DxColumnFixing :enabled="true"/>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="고객사명"
            data-field="고객사명"
            :min-width="180"
            :fixed="true"
            sort-order="asc"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="담당컨설턴트"
            data-field="컨설턴트"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="회사규모"
            data-field="회사규모"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="companyTypeLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="상장"
            data-field="상장여부"
            alignment="center"
            :min-width="60"
            >
              <DxLookup
                :data-source="openLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="업종"
            data-field="업종"
            alignment="center"
            :min-width="120"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="연매출액(억)"
            data-field="연간매출액"
            format="#,##0"
            dataType="number"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="직원수"
              data-field="종업원수"
              format="#,##0"
              dataType="number"
              :min-width="80"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="계약단계"
            data-field="계약단계"
            alignment="center"
            :min-width="90"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
              <DxLookup
                :data-source="contractLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="본사주소"
            data-field="본사주소"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="고객사소개"
            data-field="고객사소개"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="홈페이지"
            data-field="홈페이지"
            :min-width="100"
            >
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="유치경로"
            data-field="유치경로"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="infoLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="기본수수료율"
            data-field="평균수수료"
            format="#,##0.0%"
            dataType="number"
            :min-width="90"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="담당자성명"
            data-field="담당자성명"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="담당자부서"
            data-field="담당자부서"
            alignment="center"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="담당자직급"
            data-field="담당자직급"
            alignment="center"
            :min-width="100"
            :allowExporting="true"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="연락처"
            data-field="연락처"
            :min-width="110"
            :allowExporting="true"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="휴대폰"
            data-field="휴대폰"
            :min-width="110"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="이메일"
            data-field="이메일"
            :min-width="130"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="사업자번호"
            data-field="사업자번호"
            alignment="center"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="고객사코드"
            data-field="고객사코드"
            :min-width="100"
            alignment="center"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="작성자"
            data-field="createdId"
            alignment="center"
            :min-width="80"
            >
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="등록일"
            format="yyyy-MM-dd"
            data-field="createdTime"
            alignment="center"
            dataType="date"
            :min-width="90"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수정자"
            data-field="updatedId"
            alignment="center"
            :min-width="80"
            >
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수정일"
            data-field="updatedTime"
            alignment="center"
            format="yyyy-MM-dd"
            dataType="date"
            :min-width="90"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="사용유무"
            data-field="사용유무"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="삭제유무"
            data-field="삭제유무"
            :min-width="100"
            >
            </DxColumn>

            <DxColumn
              width="90"
              :buttons="editButtons"
              type="buttons"
            />
            <DxSummary>
              <DxTotalItem
                value-format='#,##0'
                show-in-column="고객사코드"
                display-format="{0} (건)"
              />
            </DxSummary>
            <dx-paging :enabled="false"/>
            <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
            <dx-sorting mode="multiple"/>
          </dx-data-grid>
        </div>
      </ResizeRow>
      <div class="detail-wrap">
        <div class="detail-title" style="margin-bottom: 8px;margin-top: 16px;">{{ customerDetail }}</div>
        <div class='sub-tab-wrap'>
          <DxTabPanel
              id="tabpanel"
              :selected-index.sync="selectedIndex"
              :data-source='tabs'
              :focusStateEnabled='true'
            >
            <template #title="{ data: tab }">
              <div class='sub-title-wrap-tab'>
                <ul>
                  <li class='float-left sub-title'>{{tab.title}}</li>
                </ul>
              </div>
            </template>
          </DxTabPanel>
          <div v-if='selectedIndex === 0'>
            <div style="margin-top: 20px;padding: 0 20px; display:flex">
              <table class="table-bordered" style="width:50%;margin-right:0%">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">본사주소</th>
                    <td >
                      {{ selectedRow.본사주소}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">홈페이지</th>
                    <td >
                      {{ selectedRow.홈페이지}}
                    </td>
                  </tr>
                  <tr style="height: 120px;">
                    <th scope="row">고객사소개</th>
                    <td >
                      {{ selectedRow.고객사소개}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-bordered" style="width:50%;">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">담당자성명</th>
                    <td >
                      {{ selectedRow.담당자성명}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">담당자부서</th>
                    <td >
                      {{ selectedRow.담당자부서}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">담당자직급</th>
                    <td >
                      {{ selectedRow.담당자직급}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">연락처</th>
                    <td >
                      {{ selectedRow.연락처}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">휴대폰</th>
                    <td >
                      {{ selectedRow.휴대폰}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">이메일</th>
                    <td >
                      {{ selectedRow.이메일}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if='selectedIndex === 1' style="margin-top: 10px;padding:0 20px;">
          <FileUploadComponent :gridHeightFile="210" :fileListInfo="fileListInfo"
            :selectedParent="selectedRow" :fileType="고객사첨부파일" :parentKey="selectedRow.seqId"
          />
        </div>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxForm,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition, DxStateStoring
} from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { ResizeRow } from 'vue-resizer'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
// Our demo infrastructure requires us to use 'file-saver-es'.
// We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter'
import FileUploadComponent from '../../share/component/FileUploadComponent.vue'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      queryStringSeqId: null,
      editButtons: ['edit', 'delete'],
      companyInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: {},
      focusedRowKey: null,
      tabs: [
        {
          title: '고객사 추가정보'
        },
        {
          title: '첨부파일 관리'
        }
      ],
      customerDetail: '고객사-추가정보',
      openLookup: ConstDef.YN_LOOKUP,
      infoLookup: this.$store.getters.getBaseDataByType(ConstDef.유치경로),
      contractLookup: this.$store.getters.getBaseDataByType(ConstDef.계약단계),
      companyTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.회사규모),
      employeeInfo: this.$store.getters.getEmployee,
      isExporing: false,
      // File upload
      fileListInfo: null,
      고객사첨부파일: ConstDef.고객사첨부파일
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxStateStoring,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxTabPanel,
    DxScrolling,
    DxForm,
    DxItem,
    ResizeRow,
    FileUploadComponent
  },
  created () {
    console.log(screen.height)
    this.gridHeight = (screen.height - 150 - 70 - 281)
    this.gridHeightFile = 210
    console.log(this.employeeInfo)
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.queryStringSeqId = this.$route.query.seqId
    this.refreshCompany()
  },
  mounted () {
    if (this.queryStringSeqId !== undefined) {
      const headTitle = this.$store.getters.headTitleByPath(this.$_, this.$router.currentRoute.path)
      if (headTitle !== null) {
        this.$emit('titleFromChild', headTitle)
      } else {
        this.$emit('titleFromChild', this.$router.currentRoute.name)
      }
    }
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isCRUD (e) {
      return (e.row.data.컨설턴트 === this.userInfo.userId ||
        this.userInfo.permission === ConstDef.SYSTEM_ADMIN)
    },
    onEditorPreparing (e) {
      if (e.dataField === '거래처코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
        console.log(this.isIdEdit)
      }
    },
    onFocusedRowChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
        this.customerDetail = `${this.selectedRow.고객사명} - 추가정보`
        this.refreshFileList()
      }
    },
    onExcelExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('고객사정보')
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '고객사정보.xlsx')
          this.isExporing = false
        })
      })
      e.cancel = true
    },
    onInitNewRow (row) {
      console.log(row)
      row.data.컨설턴트 = this.userInfo.userId
    },
    onRowDbClick (row) {
      this.$refs.refCompanyGrid.instance.editRow(row.rowIndex)
      setTimeout(() => {
        this.$Q('.dx-datagrid-edit-popup .dx-popup-bottom .dx-toolbar-after').hide()
      }, 100)
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatedTime = row.data.createdTime = this.$_appLib.getNow()
      row.data.updatedId = row.data.createdId = this.userInfo.userId
      this.$_sp.runInsertAndUpdateIdSqlProc('고객사정보', ['고객사명', 'createdTime'], ['seqId'], 'seqId', '고객사코드', 'C', this.$_appLib.deleteUnderlineKey(row.data))
        .then((data) => {
          let newData = this.$_sp.MakeModel(data)[0]
          row.data.seqId = newData.seqId
          row.data.고객사코드 = newData.고객사코드
          this.$refs.refCompanyGrid.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onRowInserting (row) {
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('고객사정보', [{ 고객사코드: row.data.고객사코드 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatedTime = this.$_appLib.getNow()
      row.data.updatedId = this.userInfo.userId
      let array = []
      array.push(this.$_appLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('고객사정보', ['고객사코드'], ['seqId'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxCheckBox',
          options: {
            value: this.isExporing,
            text: '모든 컬럼 보기',
            focusStateEnabled: true,
            onValueChanged: (args) => {
              this.isExporing = args.value
            }
          }
        }
      )
    },
    refreshCompany () {
      this.isLoading = true

      this.$_sp.runFindSqlProc('고객사정보', null)
        .then((data) => {
          this.companyInfoList = this.$_sp.MakeModel(data)
          if ((this.userInfo.permission & ConstDef.CRUD_ALLOW_경영) === 0) {
            console.log(this.userInfo.permission & ConstDef.CRUD_ALLOW_경영)
            this.companyInfoList.forEach(item => {
              if (item.컨설턴트 !== this.userInfo.userId) {
                item.담당자성명 = '***'
                item.담당자부서 = '***'
                item.담당자직급 = '***'
                item.연락처 = '***'
                item.휴대폰 = '***'
                item.이메일 = '***'
              }
            })
          }
          this.isLoading = false
          if (this.queryStringSeqId !== undefined) {
            this.focusedRowKey = parseInt(this.queryStringSeqId)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshFileList () {
      if (this.selectedRow.seqId !== undefined) {
        this.$_sp.runFindSqlProc('첨부파일정보', { 파일유형: this.고객사첨부파일, 상위코드: this.selectedRow.seqId })
          .then(data => {
            this.fileListInfo = this.$_sp.MakeModel(data)
            console.log(this.fileListInfo)
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    }

  }
}
</script>

<style lang="scss">
.table-bordered {
    width: 100%;
    margin-bottom: 0px;
    border:1px solid #acacac;
    border-collapse: collapse;
    th,td{
      border-bottom: 1px solid #acacac;
      border-right: 1px solid #acacac;
      padding: 6px;
    }
    th{
      background-color: rgb(239, 239, 239);;
    }
}
</style>
